import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../../shared/service/token.service';

export const loggedInAuthGuard = () => {
  const tokenService = inject(TokenService);
  if (tokenService.getToken()) {
    const router = inject(Router);
    router.navigate(['/dashboard']);
    return false; // Prevent activation
  }
  return true; // Allow activation if no token is found
};